<template>
  <div class="mymineClass">
    <div class="myleftNavBox">
      <div class="navImageBox">
        <el-image style="width: 115px; height: 115px"
          src="https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg" :fit="fit"></el-image>
      </div>
      <p class="myIdentity">管理员</p>
      <p class="myName">孤岛高山何其多</p>
      <div class="myLabelUl">
        <ul>
          <li><i class="el-icon-user"><span>我我我</span></i></li>
          <li><i class="el-icon-mobile-phone"><span>我我我</span></i></li>
          <li><i class="el-icon-location-outline"><span>我我我</span></i></li>
        </ul>
      </div>
    </div>
    <div class="myRightNavBox">
      <el-tabs style="width: 120px;" stretch v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="用户信息" name="first">用户信息</el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
export default {
  name: 'myMine',
  data () {
    return {
      activeName: 'first'
    }
  },
  methods: {
    handleClick (tab, event) {
      console.log(tab, event)
    }
  }
}
</script>

<style scoped lang="scss">
.mymineClass {
  height: 100%;
  width: 100%;
  display: flex;
  flex-wrap: nowrap;
  padding-right: 30px;
  /* background-color: rgb(249, 249, 249); */
}

.myleftNavBox {
  width: 30rem;
  height: 500px;
  padding: 30px 30px 0;
  margin-right: 15px;
  border-radius: 5px;
  background-color: rgb(249, 249, 249);

  p {
    text-align: center;
    margin-top: 10px;
  }

  .myIdentity {
    font-size: 1.5em;
  }

  .myName {
    color: rgb(153, 153, 153);
    font-size: 14px;
    margin-bottom: 13px;
  }

  .navImageBox {
    text-align: center;
  }

  .el-image {
    border-radius: 50%;
  }

  .myLabelUl {
    ul li {
      margin-top: 10px;
      font-size: 14px;

      span {
        margin-left: 10px;
      }
    }
  }
}

.myRightNavBox {
  width: 100%;
  background-color: rgb(249, 249, 249);
  border-radius: 5px;
}</style>
